import type { MedicationPadAlertError, ReissueStatusType } from '../../PrescriptionPad';
import { PrescriptionItemAlertType } from '../PrescriptionItemEditor.types';
import { getAvailabilityAlertType } from '../utils/getAvailabilityAlertType.utils';

type AlertTypeProps = {
  reissueStatus?: Partial<ReissueStatusType>;
  alertError: MedicationPadAlertError;
  hasActiveCancelAlert: boolean;
};

export const useAlertType = ({
  reissueStatus,
  alertError,
  hasActiveCancelAlert,
}: AlertTypeProps): PrescriptionItemAlertType | null => {
  const availabilityAlertType = getAvailabilityAlertType(reissueStatus);

  if (alertError) {
    return PrescriptionItemAlertType.ERROR;
  }

  if (hasActiveCancelAlert) {
    return PrescriptionItemAlertType.CANCEL;
  }

  if (availabilityAlertType) {
    return availabilityAlertType;
  }

  if (reissueStatus?.isReissued) {
    return PrescriptionItemAlertType.REISSUE;
  }

  return null;
};
